module.exports = __webpack_public_path__ + "img/tpc-web-10.6376a8ad.webp";